"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharCounter = exports.NoteFooter = exports.NoteTextArea = exports.NoteContainer = void 0;
const styled_1 = __importDefault(require("../../../styles/styled"));
exports.NoteContainer = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0 10px 0',
    cursor: 'default',
    width: '100%',
});
exports.NoteTextArea = styled_1.default.textarea(props => ({
    flexGrow: 0,
    fontSize: props.theme.text.size.medium,
    padding: props.theme.space[3],
    fontFamily: props.theme.text.bodyFontFamily,
    backgroundColor: props.theme.colors.grey05,
    border: `2px solid ${props.theme.colors.grey05}`,
    borderRadius: props.theme.radii[1],
    resize: 'none',
    outline: 'none',
    overflowY: 'scroll',
}), (_a) => {
    var { activeHeight, isFocused } = _a, props = __rest(_a, ["activeHeight", "isFocused"]);
    return (Object.assign({ border: isFocused ? `2px solid ${props.theme.colors.azure}` : undefined, backgroundColor: isFocused ? props.theme.colors.white : undefined }, (activeHeight
        ? {
            height: `${activeHeight + 6}px`,
        }
        : { height: '100%' })));
});
exports.NoteFooter = styled_1.default.div(({ theme }) => ({
    display: 'flex',
    margin: `${theme.space[3]}px 0 0 0`,
    width: '100%',
    alignItems: 'center',
}));
exports.CharCounter = styled_1.default.span(({ theme }) => ({
    fontSize: theme.text.size.small,
    fontFamily: theme.text.bodyFontFamily,
    fontWeight: 400,
    flexGrow: 1,
    textAlign: 'right',
    paddingRight: '12px',
}), ({ charCount, characterLimit, theme }) => {
    let countColor;
    if (charCount < characterLimit - 25) {
        countColor = theme.colors.grey30;
    }
    else {
        countColor = theme.colors.red50;
    }
    return Object.assign(Object.assign({}, (charCount === characterLimit
        ? {
            fontWeight: 'bold',
        }
        : {})), { color: countColor });
});
//# sourceMappingURL=note.styles.js.map